import { Link, tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const paragraphs = ['moreInformation.items.nextSteps.paragraph1'];
const externalLink = 'moreInformation.items.nextSteps.link';

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body>{t(paragraphs[0])}</Typography.Body>
      <Link marginTop={tokens.size.spacingMd}>
        <a
          target={'_blank'}
          rel={'noreferrer'}
          href={
            'https://www.danskebank.se/privat/produkter/bolan/infor-bostadskopet'
          }
        >
          {t(externalLink)}
        </a>
      </Link>
    </>
  );
};

export const nextStepsData = {
  key: 'next-steps-data',
  text: 'moreInformation.items.nextSteps.title',
  content: <CreateSectionContent />,
};
